// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowMoreToggle_wrapper__QusVC"};